// templates/component/Image.js
import React from 'react'
import { FoundationsImage } from '../../Types/FoundationsTypes'

function Image(props: FoundationsImage) {
    return (
        <img
            src={props.src}
            alt={props.alt}
            className={props.classes}
            style={props.customStyle}
            title={props.title}
        />
    )
}

export default Image
